exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.ec-compare-remove-button {\n  color: #D0D3DA;\n  font-size: 13px;\n  cursor: pointer;\n  position: relative;\n}\na.ec-compare-remove-button .ec-icon {\n  font-size: 16px;\n  font-weight: bold;\n  display: inline-block;\n}\na.ec-compare-remove-button:hover .ec-icon {\n  -webkit-animation: spin 0.3s ease-out;\n  animation: spin 0.3s ease-out;\n}\n@-webkit-keyframes spin {\n100% {\n    -webkit-transform: rotate(180deg);\n}\n}\n@keyframes spin {\n100% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n}", ""]);

// exports
